(function () {
  function getConfig(root) {
    var id = root.getAttribute("data-section-id");
    if (!id) return {};
    var el = document.getElementById("category-tab-config-" + id);
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function initSwipersInPanel(panel, config) {
    var desktopEl = panel.querySelector('.category-swiper-desktop[data-tab-swiper="desktop"]');
    if (desktopEl && config.desktopLayout === "slider") {
      var dPag = desktopEl.querySelector(".swiper-pagination");
      var dNext = desktopEl.querySelector(".swiper-button-next");
      var dPrev = desktopEl.querySelector(".swiper-button-prev");
      var dGap = typeof config.desktopGap === "number" ? config.desktopGap : 20;
      if (dGap < 0) dGap = 0;
      var dLg = typeof config.desktopSlidesLg === "number" ? config.desktopSlidesLg : 4;
      var opts = {
        slidesPerView: 2,
        spaceBetween: dGap,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          768: { slidesPerView: Math.min(3, dLg), spaceBetween: dGap },
          992: { slidesPerView: dLg, spaceBetween: dGap },
        },
      };
      if (dPag && config.desktopShowPagination) {
        opts.pagination = { el: dPag, clickable: true };
      }
      if (dNext && dPrev && config.desktopShowArrows) {
        opts.navigation = { nextEl: dNext, prevEl: dPrev };
      }
      new Swiper(desktopEl, opts);
    }

    var mobileEl = panel.querySelector('.category-swiper-mobile[data-tab-swiper="mobile"]');
    if (mobileEl && config.mobileLayout === "slider") {
      var mPag = mobileEl.querySelector(".swiper-pagination");
      var mSlides = typeof config.mobileSlides === "number" ? config.mobileSlides : 2;
      var mGap = typeof config.mobileGap === "number" ? config.mobileGap : 10;
      if (mGap < 0) mGap = 0;
      var mOpts = {
        slidesPerView: mSlides,
        spaceBetween: mGap,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          450: {
            slidesPerView: Math.min(3, mSlides + 1),
            spaceBetween: mGap,
          },
        },
      };
      if (mPag && config.mobileShowPagination) {
        mOpts.pagination = { el: mPag, clickable: true };
      }
      new Swiper(mobileEl, mOpts);
    }
  }

  function updateSwipers(root) {
    root.querySelectorAll(".swiper").forEach(function (el) {
      if (el.swiper) el.swiper.update();
    });
  }

  function collectionForTabIndex(root, idx) {
    return root.querySelector('.tab-collection[data-tab-index="' + idx + '"]');
  }

  function initSection(root) {
    var config = getConfig(root);
    var tabTitles = root.querySelectorAll(".tab-title");
    var tabCollections = root.querySelectorAll(".tab-collection");

    function setAriaSelected(activeTitle) {
      tabTitles.forEach(function (t) {
        // aria-pressed (not aria-selected): valid on <button> without role="tab",
        // so the aria-allowed-attr accessibility audit passes.
        t.setAttribute("aria-pressed", t === activeTitle ? "true" : "false");
      });
    }

    tabCollections.forEach(function (panel) {
      initSwipersInPanel(panel, config);
    });

    tabTitles.forEach(function (title) {
      title.addEventListener("click", function () {
        var idx = title.getAttribute("data-tab-index");
        tabTitles.forEach(function (t) {
          t.classList.remove("active");
        });
        tabCollections.forEach(function (content) {
          content.classList.remove("active");
        });
        title.classList.add("active");
        var panel = collectionForTabIndex(root, idx);
        if (panel) {
          panel.classList.add("active");
          updateSwipers(panel);
        }
        setAriaSelected(title);
      });
    });

    if (tabTitles.length > 0) {
      var first = tabTitles[0];
      var firstIdx = first.getAttribute("data-tab-index");
      first.classList.add("active");
      setAriaSelected(first);
      var firstPanel = collectionForTabIndex(root, firstIdx);
      if (firstPanel) {
        firstPanel.classList.add("active");
        updateSwipers(firstPanel);
      }
    }
  }

  function boot() {
    document.querySelectorAll(".custom-tab-feature[data-section-id]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
